<template>
  <div>
    <div class="content">
      <LoginLogo />


      <v-container>
        <v-row v-if="isLoading" class="justify-center">
          <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
              :aria-label="$t('common.loading')"
          ></v-progress-circular>
        </v-row>
        <v-row class="justify-center">
          <div v-if="errorMessage" class="bg-error">
            {{ errorMessage }}
          </div>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import AfterLoginMixin from './AfterLoginMixin.js'
import LoginLogo from './components/LoginLogo.vue'

export default {
  name: 'AccountLoginExternal',
  mixins: [AfterLoginMixin],
  components: {
    LoginLogo,
  },
  data() {
    return {
      isLoading: false,
      errorMessage: "",
    };
  },
  async mounted() {

    // Get URL hash (e.g., #error_description=...&state=...&error=...)
    const hashParams = new URLSearchParams(window.location.hash.substring(1));

    if (hashParams.has("error") || hashParams.has("error_description")) {

      if (hashParams.get("error_description").startsWith("PreSignUp failed with error Trying to link user but the destination user was not found.")) {
        this.errorMessage = "Your profile is not allowed to log in.";
        return;
      }

      // Decode and set the error message
      // this.errorMessage = decodeURIComponent(hashParams.get("error_description").replace(/\+/g, " "));

      this.errorMessage = "Error logging with external provider!";
      return;
    }

    try {
      const authStore = useAuthStore();
      const cognitoUser = await authStore.refreshCognitoUser();

      if (cognitoUser) {
        // Refresh the database user
        // It will update the uuid of the user if necessary
        let dbUser = await authStore.refreshDBUser();
        if (!dbUser) {
          this.errorMessage = 'Your profile is not allowed to log in.';
          return;
        }

        this.isLoading = true;

        // wait for few seconds to insert/update the user in the database
        await new Promise(function(resolve, reject) {
          setTimeout(function() {
            reject;
            resolve();
          }, 3000);
        });

        await this.afterLoginMixin();
        return;
      }
    } catch (e) {
      this.isLoading = false;
      console.error("Error with external login: ", e);
      this.errorMessage = "Error logging with external provider!";
    }

  }
}
</script>
